import React, { useEffect } from 'react';
import { Hero } from '../components/landing/Hero';
import { Problem } from '../components/landing/Problem';
import { HowItWorks } from '../components/landing/HowItWorks';
import { Kits } from '../components/landing/Kits';
import { Testimonials } from '../components/landing/Testimonials';
import { Guarantee } from '../components/landing/Guarantee';
import { FAQ } from '../components/landing/FAQ';
import { FinalCTA } from '../components/landing/FinalCTA';
import { Footer } from '../components/landing/Footer';
import { IsThisForYou } from '../components/landing/IsThisForYou';
import { initPixel, trackPageView } from '../lib/pixel';
export function LandingPage() {
  useEffect(() => {
    initPixel();
    trackPageView();
  }, []);
  return <div className="min-h-screen bg-[#F8F5F0] overflow-x-hidden" data-id="element-250">
      <main data-id="element-251">
        <Hero data-id="element-252" />
        <Problem data-id="element-253" />
        <Kits data-id="element-254" />
        <HowItWorks data-id="element-255" />
        <IsThisForYou data-id="element-256" />
        <Testimonials data-id="element-257" />
        <FinalCTA data-id="element-258" />
        <Guarantee data-id="element-259" />
        <FAQ data-id="element-260" />
      </main>

      <Footer data-id="element-261" />
    </div>;
}